import Vue from 'vue'
import Vuex from 'vuex'
import store from '../e5/store'
import { version } from '../../package.json'
import app from './modules/app'
// import mobile from './modules/MediaCloudPublishCenter/Mobile'
// import rootArticle from './modules/MediaCloudPublishCenter/RootArticle'
// import weixin from './modules/MediaCloudPublishCenter/Weixin'
// import douyinArticle from './modules/MediaCloudPublishCenter/DouyinArticle'
import clueDig from './modules/MediaCloudNewsPlan/ClueDig'
import cluesAdd from './modules/MediaCloudNewsPlan/CluesAdd'
import TopicAdd from './modules/MediaCloudNewsPlan/TopicAdd'
import clues from './modules/MediaCloudNewsPlan/Clues'
import topics from './modules/MediaCloudNewsPlan/Topics'
import tasks from './modules/MediaCloudNewsPlan/Tasks'
import TasksAdd from './modules/MediaCloudNewsPlan/TaskAdd'
import TaskAssign from './modules/MediaCloudNewsPlan/TaskAssign'
import photo from './modules/MediaCloudMAM/Photo'
import video from './modules/MediaCloudMAM/Video'
import audio from './modules/MediaCloudMAM/Audio'
import org from './modules/system/org'
import column from './modules/MediaCloudConfig/Column'
import userManage from './modules/MediaCloudRemoteRepository/UserManage'
import login from './modules/MediaCloudPortal/Login'
import live from './modules/MediaCloudNis/Live'
import liveConsole from './modules/MediaCloudNis/LiveConsole'
import subject from './modules/MediaCloudNis/Subject'
import subjectDetail from './modules/MediaCloudNis/SubjectDetail'
import vote from './modules/MediaCloudNis/Vote'
import tipoff from './modules/MediaCloudNis/Tipoff'
import columnRss from './modules/MediaCloudManageCenter/ColumnRss'
import columnRssDetail from './modules/MediaCloudManageCenter/ColumnRssDetail'
import releaseEnd from './modules/MediaCloudManageCenter/ReleaseEnd'
import myWorkload from './modules/MediaCloudStat/MyWorkload'
import orgWorkload from './modules/MediaCloudStat/OrgWorkload'
import screenControl from './modules/MediaCloudRemoteRepository/ScreenControl'
import dataCenter from './modules/MediaMbd/dataCenter'
import globalMessages from './modules/MediaGlobal/globalMessages'

import batman from './modules/MediaBatman/index'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    org: org,
    app: {
      state: {
        version: version,
        readChangelog: false,
        isNewsEdit: false // newsedit使用，如果是区县融媒体，设置为false,如果是融合采编，设置为true
      },
      ...app
    },
    login: {
      ...login
    },
    e5: {
      ...store
    },
    // 三方发布
    otherArticle: {
      ...store
    },
    clues: {
      // 线索管理模块e5 store  问政详情也用到了
      ...store
    },
    cluesModule: {
      // 线索管理模块store
      ...clues
    },
    // 指挥策划-选题管理模块e5 store
    topics: {
      ...store
    },
    // 指挥策划-选题管理模块store
    topicsModule: {
      ...topics
    },
    // 指挥策划-任务管理模块e5 store
    tasks: {
      ...store
    },
    // 指挥策划-任务管理store
    tasksModule: {
      ...tasks
    },
    //  指挥策划-定位控制
    tasksLocate: {
      ...store
    },
    cluesAdd: {
      ...cluesAdd
    },
    TaskAdd: {
      ...TasksAdd
    },
    TaskAssign: {
      ...TaskAssign
    },
    topicAdd: {
      ...TopicAdd
    },
    articleAdd: {
      ...store
    },
    appPushLogs: {
      // app推送日志主界面
      ...store
    },
    setSource: {
      // 新建稿件 选择来源主界面
      ...store
    },
    setExt: {
      // 新建稿件 自定义字段
      ...store
    },
    liveConsole: {
      ...liveConsole
    },
    subjectDetail: {
      ...subjectDetail
    },
    dataCenter: {
      ...dataCenter
    },
    globalMessages: {
      ...globalMessages
    },
    batman: {
      ...batman
    },
    MediaCloudNis: {
      namespaced: true,
      modules: {
        Live: {
          namespaced: true,
          ...live
        },
        Vote: {
          namespaced: true,
          ...vote
        },
        Tipoff: {
          namespace: true,
          ...tipoff
        },
        Subject: {
          namespaced: true,
          ...subject
        }
      }
    },
    MediaCloudManageCenter: {
      namespaced: true,
      modules: {
        ColumnRss: {
          namespaced: true,
          ...columnRss
        },
        ColumnRssDetail: {
          namespaced: true,
          ...columnRssDetail
        },
        ReleaseEnd: {
          namespaced: true,
          ...releaseEnd
        }
      }
    },
    mediaCloudPublishCenter: {
      namespaced: true,
      modules: {
        // mobile: {
        //   namespaced: true,
        //   ...mobile
        // },
        // RootArticle: {
        //   namespaced: true,
        //   ...rootArticle
        // },
        // Weixin: {
        //   namespaced: true,
        //   ...weixin
        // },
        // DouyinArticle: {
        //   namespaced: true,
        //   ...douyinArticle
        // }
      }
    },
    MediaCloudNewsPlan: {
      namespaced: true,
      modules: {
        clueDig: {
          namespaced: true,
          ...clueDig
        }
      }
    },
    MediaCloudConfig: {
      namespaced: true,
      modules: {
        Column: {
          namespaced: true,
          ...column
        }
      }
    },
    MediaCloudRemoteRepository: {
      namespaced: true,
      modules: {
        UserManage: {
          namespaced: true,
          ...userManage
        },
        ScreenControl: {
          namespaced: true,
          ...screenControl
        }
      }
    },
    MediaCloudStat: {
      namespaced: true,
      modules: {
        MyWorkload: {
          namespaced: true,
          ...myWorkload
        },
        OrgWorkload: {
          namespaced: true,
          ...orgWorkload
        }
      }
    },
    // 系统管理-用户机构
    MediaCloudSystemOrg: {
      ...store
    },
    // 系统管理-站点管理
    MediaCloudSystemSite: {
      ...store
    },
    // 系统管理-敏感词
    Sensitive: {
      ...store
    },
    //  系统管理-日志
    MediaCloudSystemLog: {
      ...store
    },
    //  选用记录-日志
    repositoryRRForward: {
      ...store
    },
    // 媒资——视频上传e5 store
    mamVideo: {
      ...store
    },
    // 媒资——视频上传store
    videoModule: {
      ...video
    },
    // 媒资——音频上传e5 store
    mamAudio: {
      ...store
    },
    // 媒资——音频上传store
    audioModule: {
      ...audio
    },
    // 媒资——图片上传e5 store
    mamPhoto: {
      ...store
    },
    // 媒资——回收站
    mamGarbage: {
      ...store
    },
    // 媒资——音频编目
    AudioExtFields: {
      ...store
    },
    // 媒资——视频编目
    VideoExtFields: {
      ...store
    },
    // 媒资——图片编目
    PhotoExtFields: {
      ...store
    },
    // 媒资——水印设置
    WatermarkSetting: {
      ...store
    },
    // 媒资——图片上传store
    photoModule: {
      ...photo
    },
    // 媒资——电视广播
    MediaCloudMAMTV: {
      ...store
    },
    // 媒资——智能检测
    MamAI: {
      ...store
    },
    // 内容发布——撤稿中心
    revokeCenter: {
      ...store
    },
    // 内容发布——回收站
    garbagebin: {
      ...store
    },
    // 内容发布——稿源库
    RootArticle: {
      ...store
    },
    // 内容发布——广电文稿
    TVArticle: {
      ...store
    },
    // 内容发布——广电文稿——串联单新增
    ArticleTVSelect: {
      ...store
    },
    // 管理中心-评论管理-查看举报
    discussExposeList: {
      ...store
    },
    // 运营工具-直播
    MediaCloudNisLive: {
      ...store
    },
    // 运营工具-全部报道
    MediaCloudNisLiveItem: {
      ...store
    },
    // 运营工具-投票
    MediaCloudNisVote: {
      ...store
    },
    // 运营工具-报料
    MediaCloudNisTipoff: {
      ...store
    },
    // 运营工具-话题
    MediaCloudNisSubject: {
      ...store
    },
    // 运营工具-话题-查看参与明细
    MediaCloudNisSubjectQuestions: {
      ...store
    },
    // 运营工具-话题-查看关注明细
    MediaCloudNisSubjectFollows: {
      ...store
    },
    // 运营工具-话题详情
    MediaCloudNisSubjectDetail: {
      ...store
    },
    // 运营工具-活动
    MediaCloudNisActivity: {
      ...store
    },
    // 运营工具-活动-报名
    MediaCloudNisActivityResult: {
      ...store
    },
    // 管理中心-订阅管理
    MediaCloudManageCenterColumnRss: {
      ...store
    },
    // 管理中心-订阅管理-查看
    MediaCloudManageCenterColumnRssDetail: {
      ...store
    },

    //  内容发布
    MediaCloudPublishCenter: {
      ...store
    },
    //  内容发布-微信
    MediaCloudPublishCenterWeixin: {
      ...store
    },
    //  内容发布-新建群发-微信
    MediaCloudPublishCenterWeixinArticleSelect: {
      ...store
    },
    //  内容发布-微信-群发管理
    MediaCloudPublishCenterWeixinGroup: {
      ...store
    },
    //  内容发布-微博
    MediaCloudPublishCenterWeibo: {
      ...store
    },
    //  管理中心-评论
    discuss: {
      ...store
    },
    //  管理中心-政情
    leader: {
      ...store
    },
    // 管理中心-发布端管理
    ReleaseEnd: {
      ...store
    },
    // 管理中心-发布端管理-网站-右侧区块配置
    ReleaseEndWebOverview: {
      ...store
    },
    // 管理中心-发布端管理-网站-右侧区块配置
    ReleaseEndChannelOverview: {
      ...store
    },
    //  管理中心-推荐管理
    ColumnModule: {
      ...store
    },
    //  管理中心-推荐管理——已删除列表
    ColumnModuleDeleted: {
      ...store
    },
    //  管理中心-推荐管理——选稿列表
    ColumnModuleSelect: {
      ...store
    },
    // 会员中心-邀请码
    UCInviteCode: {
      ...store
    },
    // 会员中心-邀请码-激活明细
    UCInviteCodeActive: {
      ...store
    },
    // 会员中心-邀请码-激活详情
    UCInviteCodeActiveDetail: {
      ...store
    },
    //  设置-启动页
    aDStart: {
      ...store
    },
    //  栏目设置-回收站
    columnGarbage: {
      ...store
    },
    //  会员中心-积分管理
    UCScoreRule: {
      ...store
    },
    rrTenants: {
      ...store
    },
    // 云端稿库-区划管理
    MediarrRegion: {
      ...store
    }
  }
})
